import { useEffect, useState } from "react";
import "../css/Category.css";

export default function Category({ categories, selectedCategory, onSelectCategory, jumpLink }) {
    return (
        <div className="category-container">
            <div className="category-list">
                {categories.map((category) => (
                    <div
                        key={category.id}
                        className={`category-item ${selectedCategory === category.id ? "active" : ""}`}
                        onClick={() => onSelectCategory(category.id)}
                    >
                        {category.label}
                    </div>
                ))}
                <a className="category-item category-link" href={jumpLink} target="_blank" rel="noreferrer">
                    起卦
                </a>
            </div>
            <Clock />
        </div>
    );
}

function Clock() {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setNow(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const days = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];

    return (
        <div className="time-box">
            <div className="clock">
                {`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`}
            </div>
            <div className="clock">{now.toLocaleTimeString()}</div>
            <div className="clock">{days[now.getDay()]}</div>
        </div>
    );
}
